<template>
    <b-form-row>
        <b-modal size="xl" button-size="sm" :id="this.id" ref="finder" hide-footer :title="prefix + title"
            @hidden="cancelar" @close="cancelar">
            <produto-list :isAbertoFromModal="isAbertoFromModal" :podeMudarSituacao="podeMudarSituacao"
                :podeMudarTipo="podeMudarTipo" @onDblClickProduto="produtoSelect" />
        </b-modal>

        <lg-form-input-finder v-model="localValue" fieldDescription="descricaoResumida" :label="label"
            invalidFeedback="Produto deve ser informado!" description="" @handleClean="produtoSelect"
            :showClearButton="!disabled">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed v-if="user !== null" :disabled="disabled">
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import ProdutoList from "@/modules/cadastros/produto/ProdutoList.vue"

export default {
    components: { LgFormInputFinder, ProdutoList },

    props: {
        podeMudarSituacao: {
            type: Boolean,
            default: true,
        },
        podeMudarTipo: {
            type: Boolean,
            default: true,
        },
        id: { type: String, default: 'lgfinderProduto' },
        onselect: Function,
        user: Object,
        value: Object,
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Produto",
        },
        label: {
            type: String,
            default: "Produto:",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isAbertoFromModal: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            descricao: "",
            localValue: this.value,
        }
    },

    watch: {
        value(newValue) {
            this.localValue = newValue
        },

        localValues(newValue) {
            this.$emit("onselect", newValue)
        },
    },

    methods: {
        async show() {
            await this.$refs.finder.show()
            this.$bvModal.show(this.id)
        },

        async produtoSelect(produto) {
            this.$emit("onselect", produto)
            await this.$bvModal.hide(this.id)
        },

        cancelar() {
            this.$emit("close")
        },
    },
}
</script>
